<template>
    <div>
        <HeaderPromo
            :class="{ is_modal_open: showMenu || isShowCart || isShowLocales || isShowCurrencies || isShowSearch }">
        </HeaderPromo>
        <div
            class="header"
            :class="{
                is_modal_open:
                    showMenu || isShowCart || isShowLocales || isShowCurrencies || isShowSearch || showWlNotify,
                'header-transparent': $route.name === 'index',
                scrolled: scrolled,
            }">
            <div class="header__left">
                <div
                    class="header__burger"
                    @click="
                        showMenu = !showMenu;
                        isShowSearch = false;
                        isShowCart = false;
                        isShowCategories = null;
                    "
                    :class="{ is_open: showMenu }">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <nuxt-link
                class="header__logo"
                to="/"
                @click.native="
                    showMenu = false;
                    closeProductModal();
                ">
                <img
                    data-not-lazy
                    v-lazy-load data-src="/img/logo-mobile.png"
                    v-lazy-load data-srcset="/img/logo-mobile@2x.png 2x"
                    width="166"
                    draggable="false"
                    alt="" />
                <img
                    data-not-lazy
                    v-lazy-load data-src="/img/logo-short.png"
                    v-lazy-load data-srcset="/img/logo-short@2x.png 2x"
                    height="28"
                    width="28"
                    draggable="false"
                    alt="" />
            </nuxt-link>
            <div class="header__right">
                <nuxt-link
                    class="search-toggler header__hover"
                    aria-label="Поиск"
                    to="/rezultaty-poiska"
                    @click.native="
                        isShowCart = false;
                        showMenu = false;
                        closeProductModal();
                    ">
                    <svg-icon name="search" width="32" height="32" v-if="!isShowSearch"></svg-icon>
                </nuxt-link>
                <div
                    class="header__cart"
                    @click="
                        isShowCart = true;
                        showMenu = false;
                        closeProductModal();
                    ">
                    <svg-icon name="cart" width="32" height="32" />
                    <div class="header__cart-count text_9_b" v-show="totalCartItems > 0">{{ totalCartItems }}</div>
                </div>
            </div>
            <transition name="fade">
                <div class="menu text_13" ref="menuBlock" v-if="showMenu" v-bsl="showMenu">
                    <transition name="fade" mode="out-in">
                        <div class="menu__submenu">
                            <div class="submenu-list">
                                <div v-if="!isShowCategories" class="submenu-list__top">
                                    <template v-for="(item, index) in filteredMainMenu">
                                        <div
                                            :key="`parent-${index}`"
                                            v-if="item.children"
                                            :style="`${item.mobile_margin ? 'margin-top: 24px;' : ''}color:${
                                                item.highlight || '#000'
                                            };`"
                                            class="submenu-list__item like-link submenu-list__item--gender"
                                            :class="$device.isDesktop ? 'text_13' : 'text_15'"
                                            @click="openSubmenu(item)">
                                            {{ item.title }}
                                            <svg-icon
                                                name="chevrone-right"
                                                class="color-text_3"
                                                width="16"
                                                height="16"></svg-icon>
                                        </div>
                                        <nuxt-link
                                            :key="`link-${index}`"
                                            v-else
                                            class="submenu-list__item"
                                            :style="`${item.mobile_margin ? 'margin-top: 24px;' : ''}color:${
                                                item.highlight || '#000'
                                            };`"
                                            :class="$device.isDesktop ? 'text_13' : 'text_15'"
                                            @click.native="
                                                showMenu = false;
                                                closeProductModal();
                                            "
                                            :to="item.url"
                                            >{{ item.title }}
                                        </nuxt-link>
                                    </template>
                                </div>
                                <transition name="fade">
                                    <header-drop-down-categories-by-gender
                                        v-if="isShowCategories !== null"
                                        :top="isShowCategories.children.left_top"
                                        :bottom="isShowCategories.children.left_bottom"
                                        :title="isShowCategories.title"
                                        :url="isShowCategories.url"
                                        :right="isShowCategories.children.right"
                                        @close="
                                            isShowCategories = null;
                                            showMenu = false;
                                            closeProductModal();
                                        "
                                        @update:isShowCategories="isShowCategories = $event"
                                        @back="isShowCategories = null"></header-drop-down-categories-by-gender>
                                </transition>
                            </div>
                        </div>
                    </transition>
                    <div v-if="!isShowCategories" class="menu__footer">
                        <div class="submenu-list">
                            <nuxt-link
                                @click.native="
                                    isShowCart = false;
                                    showMenu = false;
                                    closeProductModal();
                                "
                                class="submenu-list__item"
                                to="/lk/"
                                >{{ $t("account") }}</nuxt-link
                            >
                            <nuxt-link
                                @click.native="
                                    isShowCart = false;
                                    showMenu = false;
                                    closeProductModal();
                                "
                                class="submenu-list__item"
                                to="/lk/favorites/"
                                >{{ $t("favorites") }}</nuxt-link
                            >
                            <nuxt-link
                                @click.native="
                                    isShowCart = false;
                                    showMenu = false;
                                    closeProductModal();
                                "
                                class="submenu-list__item"
                                to="/faq/"
                                >{{ $t("help") }}</nuxt-link
                            >
                            <div class="submenu-list__item">
                                <div class="header__currency" @click="isShowCurrencies = true">
                                    {{ locale.lang }} /
                                    <span class="money">{{ locale.currency.currency }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="menu__footer-slogan">we re:think a norm</div>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="langs choose-modal" v-if="isShowLocales">
                    <div class="choose-modal__list" v-click-outside="() => (isShowLocales = false)">
                        <div
                            class="choose-modal__item text_11"
                            :class="{ 'choose-modal__item--current': key == $i18n.locale }"
                            v-for="(lang, key) in langs"
                            :key="lang"
                            @click="
                                $i18n.setLocale(key);
                                isShowLocales = false;
                            ">
                            <div class="choose-modal__name">{{ lang }}</div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="login-popup-wrpp" v-if="isShowLoginPopup">
                    <div class="login-popup-dimmer" @click="isShowLoginPopup = false"></div>
                    <LoginPopup
                        @close="
                            showMenu = false;
                            isShowLoginPopup = false;
                        "></LoginPopup>
                </div>
            </transition>
            <transition name="fade">
                <div class="currencies choose-modal" v-if="isShowCurrencies">
                    <div class="choose-modal__close" @click="isShowCurrencies = false">
                        <svg-icon name="close" width="32" height="32" />
                    </div>
                    <div class="choose-modal__list currency-changer">
                        <div class="currency-changer__list text_13" v-if="filteredCountries">
                            <perfect-scrollbar>
                                <div
                                    class="currency-changer__item"
                                    :class="{ 'currency-changer__item--current': key == currentCountry }"
                                    v-for="(country, key) in filteredCountries"
                                    :key="key"
                                    @click="changeCountry(key)">
                                    <span class="currency-changer__name">{{ country.fullName }}</span>
                                    <span class="money color-text_3">{{
                                        country.currency ? country.currency : country.currencyCode
                                    }}</span>
                                </div>
                            </perfect-scrollbar>
                            <div class="langs">
                                <div
                                    class="choose-modal__item"
                                    :class="{ 'choose-modal__item--current': key == $i18n.locale }"
                                    v-for="(lang, key) in langs"
                                    :key="lang"
                                    @click="changeLang(key)">
                                    <div class="choose-modal__name">{{ lang }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="liveFreshItem" :duration="300">
                <div class="wl-warn" v-if="showWlNotify">
                    <div class="fresh-item text_11">
                        <div class="fresh-item__content">
                            <div class="fresh-item__data" v-if="$auth.loggedIn">
                                <div class="flex-c color-text_2">
                                    <div class="">{{ $t("fav_added") }}</div>
                                    <div class="flex-c">
                                        <svg-icon name="wishlist" width="22" height="22" />
                                        <div v-if="wishlist.length">{{ wishlist.length }}</div>
                                    </div>
                                </div>
                                <div class="fresh-item__links flex-c">
                                    <nuxt-link to="/lk/favorites/">{{ $t("go_to_fav") }}</nuxt-link>
                                </div>
                            </div>
                            <div class="fresh-item__data" v-else>
                                <div class="color-text_2">{{ $t("fav_restrict") }}</div>
                                <div class="fresh-item__links flex-c">
                                    <nuxt-link to="/lk/login">{{ $t("login") }}</nuxt-link>
                                    <nuxt-link to="/lk/register">{{ $t("lk_register") }}</nuxt-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <client-only>
                <Cart :allowChange="true" :initIsShowCart="isShowCart" @close="isShowCart = false" />
            </client-only>
            <transition name="fade">
                <Search v-if="isShowSearch" v-bsl="isShowSearch" />
            </transition>
        </div>
    </div>
</template>
<script>
import WishlistHeart from "~/components/WishlistHeart";
import Search from "~/components/Search";
import Cart from "~/components/Cart";
import LoginPopup from "~/components/LoginPopup";
import { mapActions, mapGetters } from "vuex";
import HeaderDropDownCategoriesByGender from "~/components/HeaderDropDownCategoriesByGender";
import HeaderPromo from "./HeaderPromo.vue";
export default {
    name: "Header",
    components: {
        Cart,
        Search,
        LoginPopup,
        HeaderPromo,
        HeaderDropDownCategoriesByGender,
    },
    data() {
        return {
            isShowCategories: null,
            isShowLooks: false,
            showMenu: false,
            isShowCart: false,
            isShowLocales: false,
            isShowCurrencies: false,
            isShowSearch: false,
            currentCollectionIndex: false,
            countryQuery: "",
            isShowLoginPopup: false,
            showWlNotify: false,
            scrolled: false,
        };
    },
    computed: {
        ...mapGetters({
            wishlist: "wishlist/getIds",
            orderItems: "order/getItems",
            liveFreshItem: "order/getLiveFreshItem",
            locale: "globalvars/getLocale",
            langs: "globalvars/getLangs",
            countries: "globalvars/getCountries",
            currentCountry: "globalvars/getCurrentCountry",
            categories: "collections/getCategories",
            pages: "pages/get",
            mainMenu: "globalvars/getMainMenu",
        }),
        filteredMainMenu() {
            return this.mainMenu.filter((m) => !m.only_desktop);
        },
        isSaleActive() {
            return !!this.pages.find((p) => p.key === "open_sale" && p.is_active);
        },
        totalCartItems() {
            let count = 0;
            if (process.client) {
                for (const key in this.orderItems) {
                    if (this.orderItems.hasOwnProperty(key)) {
                        const element = this.orderItems[key];
                        count += element.count;
                    }
                }
            }
            return count;
        },

        filteredCountries() {
            if (this.countryQuery != "") {
                let list = {};
                for (const key in this.countries) {
                    if (Object.hasOwnProperty.call(this.countries, key)) {
                        const element = this.countries[key];
                        if (element.fullName.toLowerCase().indexOf(this.countryQuery.toLowerCase()) + 1) {
                            list[key] = element;
                        }
                    }
                }
                if (Object.keys(list).length) {
                    return list;
                }
                return false;
            }
            return this.countries;
        },
    },
    methods: {
        ...mapActions({
            deleteItemFromDb: "order/deleteItemFromDb",
            setOrder: "order/setOrder",
        }),
        openSubmenu(item) {
            this.isShowCategories = item;
            this.$nextTick(() => {
                this.$refs["menuBlock"].scrollTo(0, 0);
            });
        },
        closeProductModal() {
            this.$store.commit("catalog/updateProductModal", null);
        },
        getCategoryByType(categories, type) {
            let res = {};
            for (const key in categories) {
                if (Object.hasOwnProperty.call(categories, key)) {
                    const element = categories[key];
                    if (element.type == type) {
                        res[key] = element;
                    }
                }
            }
            return res;
        },
        changeCountry(country) {
            localStorage.setItem("savedCountry", country);
            this.$store.commit("globalvars/setCountry", country);
            this.$emit("update:isShowLocales", false);
        },
        changeLang(key) {
            localStorage.setItem("savedLanguage", key);
            this.$store.commit("globalvars/setLanguage", key);
            this.$i18n.setLocale(key);
            this.$emit("update:isShowLocales", false);
        },
        openCart() {
            document.querySelector("html").scrollTop = 0;
            this.isShowCart = true;
            this.showMenu = false;
        },
    },
    created() {
        this.$nuxt.$on("show-wl-notify", () => {
            this.showWlNotify = true;
            setTimeout(() => {
                this.showWlNotify = false;
            }, 3000);
        });
        this.$nuxt.$on("show-user-popup", () => {
            this.isShowLoginPopup = true;
        });
        this.$nuxt.$on("hide-user-popup", () => {
            this.isShowLoginPopup = false;
        });
    },
    mounted() {
        if (localStorage.getItem("showMeCart") == "true") {
            this.$set(this, "isShowCart", true);
            localStorage.removeItem("showMeCart");
        }

        this.$nuxt.$on("opencart", this.openCart);
        this.handleScroll = () => {
            const header = document.querySelector(".header");

            if (header) {
                this.scrolled = window.scrollY > 50;
            }
        };

        window.addEventListener("scroll", this.handleScroll);

        // сразу установить правильное состояние
        this.handleScroll();
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.header {
    .currency-changer__list {
        .ps__rail-y {
            @media @sm {
                opacity: 0 !important;
            }
        }
    }
}
</style>
<style scoped lang="less">
.search-toggler {
    height: 32px;
}
.login-popup-wrpp {
    z-index: 10;
    position: relative;
}

.login-popup-dimmer {
    background: #f2f1e9;
    opacity: 0.7;
    position: fixed;
    width: 100%;
    left: 0;
    top: 37px;
    bottom: 0;
}

.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 5;
    background: @bg;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    border-bottom: 1px solid @border2;
    .trs(transform);
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    .has-promo-header & {
        top: 40px;
    }
    a {
        transition: none;
    }
    &.header-transparent {
        background: transparent;
        border-bottom: 1px solid transparent;
        transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
        color: #fff;

        &.scrolled,
        &.is_modal_open {
            color: #000;
            background: @bg;
            border-bottom: 1px solid @border2;
        }
    }
    // .is_scrolled & {
    //     transform: translateY(-100%);
    // }

    // .has-promo-header .is_scrolled & {
    //     transform: translateY(-250%);
    // }
    &--promo {
        border-bottom: 0;
    }
    &.is_modal_open,
    &:has(.cart.editable) {
        z-index: 10002;
    }

    &__logo {
        display: grid;
        place-items: center;
        height: 36px;
        grid-template-areas: "logo";
        img {
            .trs(all);
            grid-area: logo;
            transform: scale(1);
            + img {
                opacity: 0;
                transform: scale(0.8);
            }
        }
        .scrolled & {
            img {
                opacity: 0;
                transform: scale(0.8);
                + img {
                    opacity: 1;
                    transform: scale(1);
                }
            }
        }
    }

    &__right {
        display: flex;
        align-items: center;
        margin-left: auto;
        gap: 8px;
    }

    &__cart {
        min-width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
            flex-shrink: 0;
        }
    }

    &__burger {
        width: 32px;
        height: 32px;
        position: relative;

        &.is_open {
            div:nth-child(1) {
                top: 15px;
                transform: rotate(45deg);
                transition: top 0.3s cubic-bezier(0.25, 0.1, 0.25, 1),
                    transform 0.3s 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
            }

            div:nth-child(2) {
                transform: scaleX(0);
            }

            div:nth-child(3) {
                top: 15px;
                transition: top 0.3s cubic-bezier(0.25, 0.1, 0.25, 1),
                    transform 0.3s 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
                transform: rotate(-45deg);
            }
        }

        div {
            position: absolute;
            height: 1px;
            background: currentColor;
            width: 18px;
            left: 8px;
            transform-origin: center;
        }

        div:nth-child(1) {
            top: 11px;
            transition: top 0.3s 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
        }

        div:nth-child(2) {
            top: 15px;
            .trs(transform, 0.3s, 0.15s, cubic-bezier(0.25, 0.1, 0.25, 1));
        }

        div:nth-child(3) {
            top: 19px;
            transition: top 0.3s 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
        }
    }

    &__currency {
        position: relative;

        span {
            margin-left: 5px;
        }
    }

    &__lang {
        position: relative;
    }
}

.choose-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 3;
    background: rgba(242, 241, 233, 0.7);

    &__close {
        position: absolute;
        top: 1px;
        right: 6px;
    }

    &__list {
        background: #fff;
        padding: 40px;
        margin: auto 100px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    &__item {
        display: flex;
        order: 1;

        &--current {
            order: 0;
            margin-top: 0 !important;

            &:not(:first-child) {
                margin-bottom: 16px;
            }

            > div:first-child {
                text-decoration: underline;
                text-decoration-skip-ink: none;
            }
        }

        & + & {
            margin-top: 16px;
        }

        .money {
            margin-left: 5px;
        }
    }
}

.menu {
    position: fixed;
    top: 36px;
    background: @bg;
    padding: 30px 0 0 16px;
    border-top: 1px solid @border2;
    bottom: 0;
    display: flex;
    flex-direction: column;
    right: 0;
    left: 0;
    z-index: 2;
    overflow-y: auto;

    @media @sm {
        padding-top: 24px;
    }

    .has-promo-header & {
        top: 76px;
    }

    &__back {
        padding: 16px;
        margin-left: -16px;
        margin-top: -16px;
        padding-right: 32px;
    }

    &__footer {
        border-top: 1px solid @border2;
        display: flex;
        flex-direction: column;
        margin-left: 0;
        margin-right: 16px;
        padding-top: 30px;
        div,
        a {
            width: 100%;
        }

        a {
            height: 100%;
        }
        .submenu-list__item {
            padding: 0;
            margin-bottom: 16px;
        }
    }
    &__footer-slogan {
        margin-top: 32px;
        padding-bottom: 24px;
    }

    &__submenu {
        display: flex;
        padding-bottom: 12px;
    }

    &__link {
        & + & {
            margin-top: 24px;
        }
    }

    &__super-footer {
        a {
            border-top: 1px solid @border2;
            text-align: center;
            display: block;
            line-height: 36px;
            margin-left: -16px;
        }
    }

    &__uber-footer {
        margin-top: auto;
        padding: 2px 0;
        border-top: 1px solid @border2;
        margin-left: -16px;

        .menu__link {
            justify-content: center;
        }
    }
}

@keyframes roundIn {
    from {
        clip-path: circle(0% at 50% 0);
    }
    to {
        clip-path: circle(150% at 50% 0);
    }
}

@keyframes roundOut {
    from {
        clip-path: circle(150% at 50% 0);
    }
    to {
        clip-path: circle(0% at 50% 0);
    }
}

.fresh-item {
    border-bottom: 1px solid @border2;
    border-top: 1px solid @border2;
    display: flex;
    position: fixed;
    top: 36px;
    background: #fff;
    right: 0;
    left: 0;
    z-index: 1;

    .liveFreshItem-enter-active &,
    .liveFreshItem-leave-active & {
        animation: roundIn 0.6s ease forwards;
    }

    .liveFreshItem-leave-active & {
        animation: roundOut 0.6s ease forwards;
    }

    &__img {
        width: 70px;
    }

    &__data {
        padding: 16px;
        padding-right: 100px;
        border-left: 1px solid @border2;
    }

    &__title {
        margin-bottom: 4px;
    }

    &__color {
        margin-bottom: 13px;
    }

    &__footer {
        display: flex;

        span {
            margin-right: 4px;
        }
    }

    &__count {
        margin-left: 16px;
    }
}

.submenu-list {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-right: 16px;

    & + & {
        margin-top: 24px;
    }

    &--border {
        margin-right: -16px;
        border-right: 1px @border2 solid;
    }

    &__item {
        span,
        svg {
            vertical-align: middle;
        }

        &--current {
            color: @accent;

            svg {
                margin-left: 4px;
            }
        }

        &--active {
            text-decoration: underline;
        }

        &--group {
            display: flex;
            gap: 30px;

            justify-content: space-between;
            text-align: center;
            grid-gap: 20px;
            align-items: flex-start;
        }
        &--gender {
            position: relative;
            display: flex;
            justify-content: space-between;
            gap: 8px;
            align-items: center;
            svg {
                margin-top: 0;
                position: static;
                vertical-align: unset;
            }
        }
        .like-link {
            display: flex;
            align-items: center;

            svg {
                margin-left: 18px;
            }
        }
    }
}

.currency-changer {
    margin: 0;
    padding: 32px 24px;

    &__item {
        padding: 16px 5px 0 0;
        order: 1;

        &:hover {
            color: @accent;
        }

        &--current {
            padding-top: 0;
            order: 0;

            > span:first-child {
                text-decoration: underline;
                text-decoration-skip-ink: none;
                text-underline-offset: 2px;
            }
        }

        &--empty {
            white-space: nowrap;
            padding-top: 0;
        }
    }

    &__list {
        display: flex;
        width: 100%;
        height: 100%;
        overflow: hidden;

        + .currency-changer__label {
            border-top: 1px @border2 solid;
        }
    }

    &__search {
        margin-top: 7px;
        margin-bottom: 24px;
        width: 100%;
    }

    .ps {
        height: 100%;
        display: flex;
        width: 50%;
        flex-direction: column;

        &__thumb-y {
            width: 1px;
            background: @purple;
            right: 0;
        }
    }

    .langs {
        width: 50%;
        padding: 0 16px;
        display: flex;
        flex-direction: column;
    }
}

.wl-warn {
    .fresh-item {
        top: 39px;
        &__data {
            padding-right: 16px;
            background: #fff;
        }

        &__content {
            width: 100%;
        }

        .flex-c .flex-c {
            margin-left: auto;

            svg {
                position: relative;
                top: 1px;
            }
        }

        &__links {
            margin-top: 24px;
            text-decoration: underline;

            a + a {
                margin-left: 16px;
            }
        }
    }
}

.open-block-but-better-toggler {
    justify-content: space-between;

    svg {
        .trs(transform);

        .is_open & {
            transform: rotate(180deg);
        }
    }
}
</style>
